"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateOpportunityHeldCoverNoteDto = exports.HeldCoverNoteDocumentDto = exports.RemarksDto = exports.PremiumReceiptDetailsDto = exports.DeviationsAddressedDto = exports.DeviationsDto = exports.PlacementSlipDeviationsDto = void 0;
const tslib_1 = require("tslib");
const swagger_1 = require("@nestjs/swagger");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
class PlacementSlipDeviationsDto {
}
exports.PlacementSlipDeviationsDto = PlacementSlipDeviationsDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 1,
        description: "Placement Slip Deviations",
    }),
    (0, class_validator_1.IsInt)({ message: "Placement Slip Deviations must be an integer" }),
    tslib_1.__metadata("design:type", Number)
], PlacementSlipDeviationsDto.prototype, "placementSlipDeviationsLid", void 0);
class DeviationsDto {
}
exports.DeviationsDto = DeviationsDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "Policy Data amount is incorrect",
        description: "Enter Deviations",
    }),
    (0, class_validator_1.IsString)({ message: "Enter Deviations must be a string" }),
    tslib_1.__metadata("design:type", String)
], DeviationsDto.prototype, "deviations", void 0);
class DeviationsAddressedDto {
}
exports.DeviationsAddressedDto = DeviationsAddressedDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 1,
        description: "Deviations Addressed",
    }),
    (0, class_validator_1.IsInt)({ message: "Deviations Addressed must be an integer" }),
    tslib_1.__metadata("design:type", Number)
], DeviationsAddressedDto.prototype, "deviationsAddressedLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 1,
        description: "Resolution ID",
        nullable: true,
        required: false,
        type: Number,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Resolution ID must be an integer" }),
    tslib_1.__metadata("design:type", Object)
], DeviationsAddressedDto.prototype, "resolutionLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 0,
        description: "Revised Held Cover Note",
    }),
    (0, class_validator_1.IsInt)({ message: "Revised Held Cover Note must be an integer" }),
    tslib_1.__metadata("design:type", Number)
], DeviationsAddressedDto.prototype, "revisedHeldCoverNoteLid", void 0);
class PremiumReceiptDetailsDto {
}
exports.PremiumReceiptDetailsDto = PremiumReceiptDetailsDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 12,
        description: "Acknowledged By",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Acknowledged By must be an integer" }),
    tslib_1.__metadata("design:type", Object)
], PremiumReceiptDetailsDto.prototype, "acknowledgedBy", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "PO-1000",
        description: "Receipt No",
    }),
    (0, class_validator_1.IsString)({ message: "Receipt No must be a string" }),
    tslib_1.__metadata("design:type", String)
], PremiumReceiptDetailsDto.prototype, "receiptNo", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "2025-10-15",
        description: "Receipt Date",
    }),
    (0, class_validator_1.IsString)({ message: "Receipt date must be a string." }),
    (0, class_transformer_1.Transform)(({ value }) => value ? value.trim() : value),
    (0, class_validator_1.Matches)(/^\d{4}-\d{2}-\d{2}$/, {
        message: "Receipt date must be in the format YYYY-MM-DD.",
    }),
    tslib_1.__metadata("design:type", String)
], PremiumReceiptDetailsDto.prototype, "receiptDate", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "2025-10-25",
        description: "All Documents Received Date",
    }),
    (0, class_validator_1.IsString)({ message: "All Documents Received Date must be a string." }),
    (0, class_transformer_1.Transform)(({ value }) => value ? value.trim() : value),
    (0, class_validator_1.Matches)(/^\d{4}-\d{2}-\d{2}$/, {
        message: "All Documents Received Date must be in the format YYYY-MM-DD.",
    }),
    tslib_1.__metadata("design:type", String)
], PremiumReceiptDetailsDto.prototype, "allDocumentsReceivedDate", void 0);
class RemarksDto {
}
exports.RemarksDto = RemarksDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "Key products",
        description: "Remarks",
    }),
    (0, class_validator_1.IsString)({ message: "Remarks must be a string" }),
    tslib_1.__metadata("design:type", String)
], RemarksDto.prototype, "remarks", void 0);
class HeldCoverNoteDocumentDto {
}
exports.HeldCoverNoteDocumentDto = HeldCoverNoteDocumentDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Document Type ID",
        example: 237,
    }),
    (0, class_validator_1.IsInt)({ message: "Document Type ID must be a number." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Document Type ID is required." }),
    tslib_1.__metadata("design:type", Number)
], HeldCoverNoteDocumentDto.prototype, "documentTypeLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Document ID",
        example: 25,
    }),
    (0, class_validator_1.IsInt)({ message: "Document ID must be a number." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Document ID is required." }),
    tslib_1.__metadata("design:type", Number)
], HeldCoverNoteDocumentDto.prototype, "documentId", void 0);
class CreateOpportunityHeldCoverNoteDto {
}
exports.CreateOpportunityHeldCoverNoteDto = CreateOpportunityHeldCoverNoteDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 1,
        description: "Opportunity Activity ID(mandatory field)",
    }),
    (0, class_validator_1.IsInt)({ message: "Opportunity Activity ID must be an integer" }),
    tslib_1.__metadata("design:type", Number)
], CreateOpportunityHeldCoverNoteDto.prototype, "opportunityActivityId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 1,
        description: "Status",
    }),
    (0, class_validator_1.IsInt)({ message: "Status must be an integer" }),
    tslib_1.__metadata("design:type", Number)
], CreateOpportunityHeldCoverNoteDto.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: PlacementSlipDeviationsDto }),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => PlacementSlipDeviationsDto),
    tslib_1.__metadata("design:type", PlacementSlipDeviationsDto)
], CreateOpportunityHeldCoverNoteDto.prototype, "placementSlipDeviationsSection", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: DeviationsDto }),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => DeviationsDto),
    tslib_1.__metadata("design:type", DeviationsDto)
], CreateOpportunityHeldCoverNoteDto.prototype, "deviationSection", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: DeviationsAddressedDto }),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => DeviationsAddressedDto),
    tslib_1.__metadata("design:type", DeviationsAddressedDto)
], CreateOpportunityHeldCoverNoteDto.prototype, "deviationsAddressedSection", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: PremiumReceiptDetailsDto }),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => PremiumReceiptDetailsDto),
    tslib_1.__metadata("design:type", PremiumReceiptDetailsDto)
], CreateOpportunityHeldCoverNoteDto.prototype, "premiumReceiptDetailsSection", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: RemarksDto }),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => RemarksDto),
    tslib_1.__metadata("design:type", RemarksDto)
], CreateOpportunityHeldCoverNoteDto.prototype, "remarksSection", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Array of documents",
        type: [HeldCoverNoteDocumentDto],
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)({ message: "Documents must be an array." }),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => HeldCoverNoteDocumentDto),
    tslib_1.__metadata("design:type", Array)
], CreateOpportunityHeldCoverNoteDto.prototype, "documents", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 1,
        description: "Created By",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Created By must be an integer" }),
    tslib_1.__metadata("design:type", Number)
], CreateOpportunityHeldCoverNoteDto.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 2,
        description: "Updated By",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Updated By must be an integer" }),
    tslib_1.__metadata("design:type", Number)
], CreateOpportunityHeldCoverNoteDto.prototype, "updatedBy", void 0);
